import { Chakra } from "@airhelp/react-ui-components";
import type { PagesListProps } from "./PagesList.d";
import Dots from "./Dots";

const { List, ListItem, HStack, Text } = Chakra;

const PagesList = ({ pages, onPageClick, currentPage }: PagesListProps) => (
  <List>
    <HStack>
      {pages.map((item, idx) => {
        // eslint-disable-next-line react/no-array-index-key
        if (typeof item === "string") return <Dots key={item + idx} />;

        return (
          <ListItem
            cursor="pointer"
            p={3}
            rounded="md"
            onClick={() => onPageClick(item - 1)}
            key={item}
            bg={currentPage === item ? "white" : "none"}
          >
            <Text fontSize="sm">{item}</Text>
          </ListItem>
        );
      })}
    </HStack>
  </List>
);

export default PagesList;
